import { useEffect, useState, RefObject } from "react";

export function useScrollToBottomButton(scrollRef: RefObject<HTMLElement>) {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const container = scrollRef.current;

    if (!container) return;

    const checkScrollPosition = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const isNearBottom = scrollHeight - scrollTop - clientHeight < 100;
      setShowScrollButton(!isNearBottom);
    };

    // Check initial scroll position
    checkScrollPosition();

    // Listen to scroll events
    container.addEventListener("scroll", checkScrollPosition);

    // Listen to content size changes (when new messages are added)
    const resizeObserver = new ResizeObserver(() => {
      checkScrollPosition();
    });
    resizeObserver.observe(container);

    return () => {
      container.removeEventListener("scroll", checkScrollPosition);
      resizeObserver.disconnect();
    };
  }, [scrollRef]);

  const scrollToBottom = () => {
    const container = scrollRef.current;
    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  return {
    showScrollButton,
    scrollToBottom,
  };
}
